<mat-card-content>
    <div style="display: flex; gap: 16px; margin-bottom: 16px;margin-left: 16px;">
      <button mat-raised-button color="primary" (click)="OpenEntryDialog()"  *ngIf="role === 1">
        <mat-icon>add</mat-icon> Create Organization
    </button>
    </div>
    <section>
 
        <div *ngIf="!hasError">
            <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
  <mat-form-field appearance="outline">
    <mat-label>Search</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search Organization">
  </mat-form-field>
</div> 
          <table *ngIf="organization && organization.data.length > 0" mat-table [dataSource]="organization" class="mat-elevation-z8">
            <ng-container matColumnDef="organizationName">
              <th mat-header-cell *matHeaderCellDef> Organization Name </th>
              <td mat-cell *matCellDef="let organization" matTooltip="organizationName: {{ organization.organizationName }}"> 
                {{ organization.organizationName }} 
              </td>
            </ng-container>
            
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef> City </th>
              <td mat-cell *matCellDef="let organization" matTooltip="city: {{ organization.city }}"> 
                {{ organization.city }} 
              </td>
            </ng-container>
      
            <ng-container matColumnDef="province">
              <th mat-header-cell *matHeaderCellDef> Province </th>
              <td mat-cell *matCellDef="let organization" matTooltip="province: {{ organization.province }}"> 
                {{ organization.province }} 
              </td>
            </ng-container>
      
            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef> Country </th>
              <td mat-cell *matCellDef="let organization" matTooltip="country: {{ organization.country }}"> 
                {{ organization.country }} 
              </td>
            </ng-container>
      
            <ng-container matColumnDef="postalCode">
              <th mat-header-cell *matHeaderCellDef> Postal Code </th>
              <td mat-cell *matCellDef="let organization" matTooltip="postalCode: {{ organization.postalCode }}"> 
                {{ organization.postalCode }} 
              </td>
            </ng-container>
      
            <ng-container matColumnDef="createdDateTime">
              <th mat-header-cell *matHeaderCellDef> Created Date </th>
              <td mat-cell *matCellDef="let organization" matTooltip="Created Date: {{ datePipe.transform(organization.createdDateTime, 'MM/dd/yyyy') }}"> 
                {{ datePipe.transform(organization.createdDateTime, 'MM/dd/yyyy') }} 
              </td>
            </ng-container>
            <ng-container matColumnDef="SessionTimeout">
              <th mat-header-cell *matHeaderCellDef class="actions-header center-header"> Session Timeout(minutes) </th>
              <td mat-cell *matCellDef="let organization" class="actions-cell">
                <div class="action-icons-container">
                  <button mat-icon-button matTooltip="Manage Session Timeout(minutes)" (click)="OpenSeessionTimeoutDialog(organization.id,organization.organizationName)">
                    <mat-icon color="primary" class="small-icon">access_time</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="status-header"> Status </th>
              <td mat-cell *matCellDef="let organization" class="status-cell" matTooltip="Status: {{ getStatus(organization.status) }}">
                <span [ngClass]="{
                  'warn': organization.status === 0,
                  'active': organization.status === 1,
                  'trial': organization.status === 2
                }">
                  {{ getStatus(organization.status) }}
                </span>
              </td>
            </ng-container>
      
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="actions-header center-header" style="width: 150px;"> Actions </th>
              <td mat-cell *matCellDef="let organization" class="actions-cell">
                <div class="action-icons-container">
                  <button mat-icon-button matTooltip="Manage Users" (click)="OpenUserDialog(organization.id,organization.organizationName)">
                    <mat-icon color="primary" class="small-icon">groups</mat-icon>
                  </button>
                  
                  <button mat-icon-button matTooltip="Edit Organization" (click)="OpenEditDialog(organization.id)" [disabled]="role !== 1">
                    <mat-icon [ngClass]="role === 1 ? 'blue-icon' : 'grey-icon'" class="small-icon">edit</mat-icon>
                  </button>
      
                  <button mat-icon-button matTooltip="Deactivate Organization" (click)="updateOrganizationState(organization.id,organization.organizationName)"  [disabled]="role !== 1">
                    <mat-icon [ngClass]="{'red-icon': role === 1, 'disabled-icon': role !== 1}">
                      
                      delete_forever
                    </mat-icon>
                  </button>
                  
                </div>
              </td>
            </ng-container>
      
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let user; columns: displayedColumns;"></tr>
          </table>
      
          <!-- Display message if the organization array is empty -->
          <div *ngIf="!organization || organization.data.length === 0" class="no-data-message">
           {{message}}
          </div>
        </div>
      </section>
       <mat-paginator
  [length]="organization.data.length"
  [pageSize]="5"
  [pageSizeOptions]="[5, 10, 25, 100]"
  showFirstLastButtons>
</mat-paginator>
</mat-card-content>
